module.exports = __webpack_public_path__ + "img/category_lafia_castle.772bc6d9.png";